import page from 'page'
import appStarterPg from '../../config/app-starter-pg.js'
import { showPageUserProfile } from './profile/index.js'
import { showPageUserAccounts } from './app-user-accounts/index.js'
import { contentElementId } from '../../config/config.js'
import { browserAppUser } from '../../helpers/app-data-loaders/app-user.js'

export function setupUserRoutes (baseRoute) {
  page(`${baseRoute}`, async function (context) {
    await appStarterPg()
    const afterLoginRedirectUrl = localStorage.getItem('afterLoginRedirectUrl')

    if (afterLoginRedirectUrl) {
      localStorage.removeItem('afterLoginRedirectUrl')
      location.href = afterLoginRedirectUrl
      return
    }

    showPageUserProfile({
      containerElementId: contentElementId,
      browserAppUser
    })
  })

  page(`${baseRoute}/user-accounts`, async function (context) {
    await appStarterPg()
    showPageUserAccounts({
      containerElementId: contentElementId,
      browserAppUser
    })
  })
}
